module.exports = __webpack_public_path__ + "img/search-engine.8b021655.jpg";